// extracted by mini-css-extract-plugin
export default {"cls1":"CenteredDiv-cls1___99a0cd510b239d4a078","cls2":"CenteredDiv-cls2___d835da1742b5620a899 CenteredDiv-cls1___99a0cd510b239d4a078"};